const DEFAULT_SITE_URL = (process.env.NEXT_PUBLIC_SITE_URL || "https://asangsm.com").replace(/\/$/, "");
const IMAGE_BASE = (process.env.IMAGE_URL || "").replace(/\/$/, "");

const HTTP_REGEX = /^https?:\/\//i;

const withLeadingSlash = (value: string) => (value.startsWith("/") ? value : `/${value}`);
const normalizeBase = (value: string) => (value.endsWith("/") ? value.slice(0, -1) : value);

export const SITE_DOMAIN = normalizeBase(DEFAULT_SITE_URL);

export const ensureAbsoluteUrl = (path?: string, base?: string): string => {
  const resolvedBase = normalizeBase(base || SITE_DOMAIN);
  if (!path) return resolvedBase;
  if (HTTP_REGEX.test(path)) {
    return path;
  }
  return `${resolvedBase}${withLeadingSlash(path)}`;
};

export const resolveMediaUrl = (path?: string, fallbackBase?: string): string => {
  if (!path) return "";
  if (HTTP_REGEX.test(path)) {
    return path;
  }
  const baseCandidate = IMAGE_BASE || fallbackBase || SITE_DOMAIN;
  const normalizedBase = normalizeBase(baseCandidate);
  return `${normalizedBase}${withLeadingSlash(path)}`;
};

export const buildProductPath = (slug?: string): string => {
  if (!slug) return "/";

  // Product slugs are authoritative; only normalize space representations so
  // the public path stays identical everywhere it is linked or serialized.
  const publicSlug = slug.trim().replace(/(?:\s|%20)+/gi, "-");
  return `/product/${publicSlug}`;
};

export const buildProductUrl = (slug?: string, base?: string): string => {
  return ensureAbsoluteUrl(buildProductPath(slug), base);
};
